type ServicesManager = {
  services: {
    viewportGridService: {
      getState: () => {
        activeViewportId: string;
        viewports: Map<
          string,
          { displaySetInstanceUIDs?: string[]; viewportOptions?: { viewportId?: string } }
        >;
      };
    };
    displaySetService: {
      getDisplaySetByUID: (uid: string) => { StudyInstanceUID?: string } | undefined;
    };
  };
};

/** Resolve the study a structured report should be stored under. */
export function resolveStudyInstanceUIDForSave(
  servicesManager: ServicesManager,
  {
    studyInstanceUID,
    viewportId,
  }: {
    studyInstanceUID?: string | null;
    viewportId?: string | null;
  }
): string | undefined {
  if (studyInstanceUID?.trim()) {
    return studyInstanceUID.trim();
  }

  const { viewportGridService, displaySetService } = servicesManager.services;
  const { activeViewportId, viewports } = viewportGridService.getState();
  const resolvedViewportId = viewportId || activeViewportId;

  if (!resolvedViewportId) {
    return undefined;
  }

  const viewport = viewports.get(resolvedViewportId);
  const displaySetInstanceUID = viewport?.displaySetInstanceUIDs?.[0];

  if (!displaySetInstanceUID) {
    return undefined;
  }

  return displaySetService.getDisplaySetByUID(displaySetInstanceUID)?.StudyInstanceUID;
}
